/**
 * Cache time constants for Next.js cache control headers
 *
 * These constants align with ADR 0029 (Caching Strategy) requirements.
 * Values are used in route segment configs (revalidate) and API route headers.
 *
 * @see docs/adrs/0029-caching-strategy.md
 */
const THIRTY_SECONDS = 30;
const ONE_MINUTE_IN_SECONDS = 60;
const FIVE_MINUTES_IN_SECONDS = 300;
const TEN_MINUTES_IN_SECONDS = 600;
const ONE_HOUR_IN_SECONDS = 3600;
const ONE_DAY_IN_SECONDS = 86400;
const SEVEN_DAYS_IN_SECONDS = 604800;
const ONE_YEAR_IN_SECONDS = 31536000;

const PRIVATE_CACHE_CONTROL = 'private, no-store';

export {
  FIVE_MINUTES_IN_SECONDS,
  ONE_DAY_IN_SECONDS,
  ONE_HOUR_IN_SECONDS,
  ONE_MINUTE_IN_SECONDS,
  ONE_YEAR_IN_SECONDS,
  PRIVATE_CACHE_CONTROL,
  SEVEN_DAYS_IN_SECONDS,
  TEN_MINUTES_IN_SECONDS,
  THIRTY_SECONDS,
};
